var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ApplicationWrapper",
    { attrs: { hideHeader: false } },
    [
      _c("template", { slot: "header" }, [
        _c("b", [
          _c("h2", [_vm._v(_vm._s(_vm.$t("common.label_errorOccured")))]),
        ]),
      ]),
      _c(
        "template",
        { slot: "details" },
        [
          _c(
            "v-row",
            { staticClass: "my-4", attrs: { "no-gutters": "" } },
            [
              _c(
                "v-col",
                { staticClass: "d-flex align-center px-4" },
                [
                  _c(
                    "Detail",
                    {
                      staticClass: "text-center ma-0",
                      attrs: {
                        containerNoPadding: true,
                        containerNoMargin: true,
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c("v-list-item-title", [
                            _c("b", [
                              _c("u", [
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(_vm.$t("common.label_requestInfo"))
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "px-1" },
                            [
                              _c("br"),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          readonly: "",
                                          error: "",
                                          filled: "",
                                          color: "error",
                                          "append-icon": "mdi-content-copy",
                                          label: _vm.$t(
                                            "common.label_controller"
                                          ),
                                        },
                                        on: {
                                          "click:append": function ($event) {
                                            return _vm.copyToClipboard(
                                              _vm.errorObj.controller
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.errorObj.controller,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.errorObj,
                                              "controller",
                                              $$v
                                            )
                                          },
                                          expression: "errorObj.controller",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          readonly: "",
                                          error: "",
                                          filled: "",
                                          color: "error",
                                          "append-icon": "mdi-content-copy",
                                          label: _vm.$t("common.label_action"),
                                        },
                                        on: {
                                          "click:append": function ($event) {
                                            return _vm.copyToClipboard(
                                              _vm.errorObj.action
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.errorObj.action,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.errorObj,
                                              "action",
                                              $$v
                                            )
                                          },
                                          expression: "errorObj.action",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("br"),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          readonly: "",
                                          error: "",
                                          filled: "",
                                          color: "error",
                                          "append-icon": "mdi-content-copy",
                                          label: _vm.$t(
                                            "common.label_axiosError"
                                          ),
                                        },
                                        on: {
                                          "click:append": function ($event) {
                                            return _vm.copyToClipboard(
                                              _vm.errorObj.axiosErrorCode
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.errorObj.axiosErrorCode,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.errorObj,
                                              "axiosErrorCode",
                                              $$v
                                            )
                                          },
                                          expression: "errorObj.axiosErrorCode",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "v-col",
                                    [
                                      _c("v-text-field", {
                                        attrs: {
                                          readonly: "",
                                          error: "",
                                          filled: "",
                                          color: "error",
                                          "append-icon": "mdi-content-copy",
                                          label: _vm.$t(
                                            "common.label_httpStatus"
                                          ),
                                        },
                                        on: {
                                          "click:append": function ($event) {
                                            return _vm.copyToClipboard(
                                              _vm.errorObj.httpStatus
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.errorObj.httpStatus,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.errorObj,
                                              "httpStatus",
                                              $$v
                                            )
                                          },
                                          expression: "errorObj.httpStatus",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c("br"),
                              _c(
                                "v-row",
                                [
                                  _c(
                                    "v-col",
                                    [
                                      _c("v-textarea", {
                                        attrs: {
                                          readonly: "",
                                          error: "",
                                          filled: "",
                                          color: "error",
                                          "append-icon": "mdi-content-copy",
                                          "auto-grow": "",
                                          rows: "2",
                                          label: _vm.$t(
                                            "common.label_fullRoute"
                                          ),
                                        },
                                        on: {
                                          "click:append": function ($event) {
                                            return _vm.copyToClipboard(
                                              _vm.errorObj.fullRoute
                                            )
                                          },
                                        },
                                        model: {
                                          value: _vm.errorObj.fullRoute,
                                          callback: function ($$v) {
                                            _vm.$set(
                                              _vm.errorObj,
                                              "fullRoute",
                                              $$v
                                            )
                                          },
                                          expression: "errorObj.fullRoute",
                                        },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                {
                                  staticClass: "text-center",
                                  attrs: { "no-gutters": "" },
                                },
                                [
                                  _c("v-col", [
                                    _c("b", [
                                      _c("u", [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$t("common.label_paramInfo")
                                            ) +
                                            " "
                                        ),
                                      ]),
                                    ]),
                                  ]),
                                ],
                                1
                              ),
                              _c(
                                "v-row",
                                [
                                  _vm.errorObj.routeParameters &&
                                  _vm.errorObj.routeParameters.length > 0
                                    ? _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "v-card",
                                            { staticClass: "ma-2 pa-1" },
                                            [
                                              _c(
                                                "v-row",
                                                [
                                                  _c("v-col", [
                                                    _c("u", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.label_routeParameter"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "text-left",
                                                      attrs: { cols: "4" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.label_number"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "text-left",
                                                      attrs: { cols: "auto" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.label_paramValue"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._l(
                                                _vm.errorObj.routeParameters,
                                                function (routeParam, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "routeparam_" +
                                                        index +
                                                        "_" +
                                                        routeParam,
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "text-left",
                                                              attrs: {
                                                                cols: "4",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    index +
                                                                      1 +
                                                                      "."
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "text-left",
                                                              attrs: {
                                                                cols: "auto",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    routeParam
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm.errorObj.queryParameters &&
                                  _vm.errorObj.queryParameters.length > 0
                                    ? _c(
                                        "v-col",
                                        { attrs: { cols: "6" } },
                                        [
                                          _c(
                                            "v-card",
                                            { staticClass: "ma-2 pa-1" },
                                            [
                                              _c(
                                                "v-row",
                                                [
                                                  _c("v-col", [
                                                    _c("u", [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.label_queryParameter"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]),
                                                  ]),
                                                ],
                                                1
                                              ),
                                              _c(
                                                "v-row",
                                                [
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "text-left",
                                                      attrs: { cols: "6" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.label_paramName"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "v-col",
                                                    {
                                                      staticClass: "text-left",
                                                      attrs: { cols: "auto" },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            _vm.$t(
                                                              "common.label_paramValue"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ],
                                                1
                                              ),
                                              _vm._l(
                                                _vm.errorObj.queryParameters,
                                                function (queryParam, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key:
                                                        "routeparam_" +
                                                        index +
                                                        "_" +
                                                        queryParam.key,
                                                    },
                                                    [
                                                      _c(
                                                        "v-row",
                                                        [
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "text-left",
                                                              attrs: {
                                                                cols: "6",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    queryParam.key
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                          _c(
                                                            "v-col",
                                                            {
                                                              staticClass:
                                                                "text-left",
                                                              attrs: {
                                                                cols: "auto",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                " " +
                                                                  _vm._s(
                                                                    queryParam.value
                                                                  ) +
                                                                  " "
                                                              ),
                                                            ]
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                    ],
                                                    1
                                                  )
                                                }
                                              ),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
              _c(
                "v-col",
                { staticClass: "d-flex align-center px-4" },
                [
                  _c(
                    "Detail",
                    {
                      staticClass: "text-center ma-0",
                      attrs: {
                        containerNoPadding: true,
                        containerNoMargin: true,
                      },
                    },
                    [
                      _c(
                        "template",
                        { slot: "header" },
                        [
                          _c("v-list-item-title", [
                            _c("b", [
                              _c("u", [
                                _c("h4", [
                                  _vm._v(
                                    _vm._s(_vm.$t("common.label_errorMessage"))
                                  ),
                                ]),
                              ]),
                            ]),
                          ]),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "px-1" },
                            [
                              _c("br"),
                              _c("v-textarea", {
                                attrs: {
                                  readonly: "",
                                  error: "",
                                  filled: "",
                                  color: "error",
                                  "append-icon": "mdi-content-copy",
                                  "auto-grow": "",
                                  rows: "2",
                                  label: _vm.$t("common.label_errorName"),
                                },
                                on: {
                                  "click:append": function ($event) {
                                    return _vm.copyToClipboard(
                                      _vm.errorObj.errorName
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.errorObj.errorName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.errorObj, "errorName", $$v)
                                  },
                                  expression: "errorObj.errorName",
                                },
                              }),
                              _c("br"),
                              _c("v-textarea", {
                                attrs: {
                                  readonly: "",
                                  error: "",
                                  filled: "",
                                  color: "error",
                                  "append-icon": "mdi-content-copy",
                                  "auto-grow": "",
                                  rows: "4",
                                  label: _vm.$t("common.label_errorMessage"),
                                },
                                on: {
                                  "click:append": function ($event) {
                                    return _vm.copyToClipboard(
                                      _vm.errorObj.errorMessage
                                    )
                                  },
                                },
                                model: {
                                  value: _vm.errorObj.errorMessage,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.errorObj, "errorMessage", $$v)
                                  },
                                  expression: "errorObj.errorMessage",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    2
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "template",
        { slot: "actionbuttons" },
        [
          _c(
            "v-row",
            { attrs: { justify: "space-around", align: "center" } },
            [
              _c(
                "v-btn",
                { attrs: { color: "primary" }, on: { click: _vm.backToLogin } },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v(" mdi-arrow-left "),
                  ]),
                  _vm._v(
                    " " + _vm._s(_vm.$t("common.label_backToLogin")) + " "
                  ),
                ],
                1
              ),
              _c(
                "v-btn",
                {
                  attrs: { color: "primary" },
                  on: {
                    click: function ($event) {
                      return _vm.copyToClipboard(_vm.window.location.href)
                    },
                  },
                },
                [
                  _c("v-icon", { attrs: { left: "" } }, [
                    _vm._v(" mdi-content-copy "),
                  ]),
                  _vm._v(
                    " " + _vm._s(_vm.$t("common.label_copyErrorUrl")) + " "
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }